import { signOut } from 'next-auth/react';
import { useMutation } from '@tanstack/react-query';
import { api } from '@/libs/axios/api';
import { apiConfig } from '@/config/api';

const deleteAccount = async () => {
  await api.post(apiConfig.routes.customer.delete);
};

export const useDeleteAccount = () => {
  return useMutation({
    mutationFn: deleteAccount,
    onSuccess: () => signOut(),
  });
};
